(function () {
  const locale =
    (window.Shopify && Shopify.locale) ||
    (document.documentElement.lang || "en").slice(0, 2);

  const MESSAGES = {
    hu: "Ajándék termékből legfeljebb 1 db tehető a kosárba.",
    en: "You can add a maximum of 1 gift item to your cart.",
    sk: "Do košíka je možné pridať najviac 1 darčekový produkt.",
  };

  const msg = MESSAGES[locale] || `${MESSAGES.hu} / ${MESSAGES.en} / ${MESSAGES.sk}`;

  const KNOWN_PATTERNS = [
    "You can only order a maximum of 1",
    "Maximum quantity is 1",
    "Max 1 per cart",
    "Max 1 per line"
  ];

  function shouldReplace(text) {
    if (!text) return false;
    const t = text.trim().toLowerCase();
    return KNOWN_PATTERNS.some(p => t.includes(p.toLowerCase()));
  }

  function replaceOnce(root = document) {
    const nodes = root.querySelectorAll('.f-notification.warning .ml-3, .f-notification.warning [class*="message"], .f-notification.warning');
    nodes.forEach(el => {
      const txt = el.textContent || "";
      if (shouldReplace(txt)) {
        el.textContent = msg;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    replaceOnce();

    const mo = new MutationObserver((muts) => {
      muts.forEach(m => {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(n => {
            if (n.nodeType === 1) replaceOnce(n);
          });
        }
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
